import React from 'react';
import ReactApexChart from "react-apexcharts";

const SingleBarChart = ({ data }) => {
    const chartData = {
        series: [
            {
                name: "Revenue",
                data: data.map((item) => item.value),
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 350,
                toolbar: {
                    show: false, // Hide the chart toolbar
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '60%', // Adjust the width of bars
                    endingShape: 'rounded', // Rounded edges for bars
                },
            },
            dataLabels: {
                enabled: true, // Display data labels on the bars
                style: {
                    colors: ['#fff'], // White text color for data labels
                },
                formatter: (val) => `${val}Rs`, // Format the label with a dollar sign
            },
            xaxis: {
                categories: data?.map((item) => item?.label),
                title: {
                    text: "Time Period",
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#333',
                    },
                },
                labels: {
                    rotate: -45, // Rotate the labels for better readability
                },
            },
            yaxis: {
                title: {
                    text: "Revenue",
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#333',
                    },
                },
                labels: {
                    formatter: (val) => `${val}Rs`, // Format the y-axis values
                },
            },
            tooltip: {
                enabled: true,
                y: {
                    formatter: (val) => `${val}Rs`, // Format tooltip values
                },
            },
            colors: ['#1E90FF', '#32CD32'], // Set two colors for the bars, can be dynamic based on data
            title: {
                text: 'Revenue Overview',
                align: 'center',
                style: {
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#333',
                },
            },
        },
    };

    return (
        <div>
            <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="bar"
                height={350}
            />
        </div>
    );
};

export default SingleBarChart;
